import EN from './en'
import FR from './fr'

const translations = { EN, FR }

export default translations